import { HisBaseGlobalsService } from 'hisng';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TravelItinerary, TravelItineraryWithPosition } from '../../model/travelitinerary';
import { formatDate } from '@angular/common';
import {
    ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER,
    ENGLISH_DATE_TIME_PIPE_FORMAT,
    GERMAN_DATE_TIME_FORMAT_PLACEHOLDER,
    GERMAN_DATE_TIME_PIPE_FORMAT
} from 'app/rm/erp/common/model/constants';
@Component( {
    selector: 'erp-businesstripapplication-travel-itinerary',
    templateUrl: './businesstripapplication-travel-itinerary.component.html'
} )
export class BusinesstripApplicationTravelItineraryComponent implements OnInit, OnChanges {
    @Input() listTravelitinerary?: TravelItinerary[] | null = [];
    @Output() travelItineraryChange = new EventEmitter<TravelItinerary[]>();
    readonly currentDate: string = formatDate( Date.now(), 'yyyy-MM-dd', 'de-DE' );
    readonly dateTimeFormat: string;
    readonly dateTimePlaceholderFormat: string;

    public travelItineraryWithPosition: TravelItineraryWithPosition =
        { position: -1, travelItinerary: new TravelItinerary(), isNewElement: true };
    public isInputDialogVisible = false;
    public isDeleteAllButtonDisabled = true;

    constructor( private readonly hisBaseGlobalsService: HisBaseGlobalsService, ) {
        if ( this.hisBaseGlobalsService.getLanguage() === 'de' ) {
            this.dateTimeFormat = GERMAN_DATE_TIME_PIPE_FORMAT;
            this.dateTimePlaceholderFormat = GERMAN_DATE_TIME_FORMAT_PLACEHOLDER;
        } else {
            this.dateTimeFormat = ENGLISH_DATE_TIME_PIPE_FORMAT;
            this.dateTimePlaceholderFormat = ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER;
        }
    }

    ngOnInit(): void {
    }

    openInputDialog(): void {
        this.travelItineraryWithPosition = { position: -1, travelItinerary: new TravelItinerary(), isNewElement: true };
        this.isInputDialogVisible = true;
    }

    editTravelitinerary( elementPosition: number ) {
        if ( this.listTravelitinerary && this.listTravelitinerary.length > elementPosition ) {
            let tempTravelitinerary: TravelItinerary | undefined = this.listTravelitinerary[elementPosition];
            if ( tempTravelitinerary !== undefined ) {
                this.travelItineraryWithPosition = {
                    position: elementPosition, travelItinerary: { ...tempTravelitinerary },
                    isNewElement: false
                };
            }
        }
        this.isInputDialogVisible = true;
    }

    deleteTravelitinerary( elementPosition: number ): void {
        if ( this.listTravelitinerary && this.listTravelitinerary.length > elementPosition ) {
            this.listTravelitinerary.splice( elementPosition, 1 );
            this.isDeleteButtonToShow();
        }
    }

    isDeleteButtonToShow(): void {
        if ( this.listTravelitinerary && this.listTravelitinerary.length > 0 ) {
            this.isDeleteAllButtonDisabled = false;
        } else {
            this.isDeleteAllButtonDisabled = true;
        }
    }

    deleteAllTravelitinerary(): void {
        if ( this.listTravelitinerary ) {
            this.listTravelitinerary.splice( 0, this.listTravelitinerary.length );
            this.isDeleteAllButtonDisabled = true;
            this.travelItineraryChange.emit( this.listTravelitinerary );
        }
    }

    addTravelItineraryAndCloseInputDialog(): void {
        if ( this.listTravelitinerary ) {
            if ( this.travelItineraryWithPosition?.isNewElement ) {
                this.listTravelitinerary.push( this.travelItineraryWithPosition.travelItinerary );

            } else {
                this.listTravelitinerary[this.travelItineraryWithPosition.position] = this.travelItineraryWithPosition?.travelItinerary;
            }
            this.travelItineraryChange.emit( this.listTravelitinerary );
        }
        this.closeInputDialog();
        this.isDeleteButtonToShow();
    }

    closeInputDialog(): void {
        this.isInputDialogVisible = false;
    }

    ngOnChanges( changes: SimpleChanges ) {
        // Necessary if inputvalue is provided by parent component
        this.isDeleteButtonToShow();
    }
}


